export default __webpack_public_path__ + "89d73a4718db4e06b32b95f1ca3a01a77d430cdc91da63fea4961c4dd551cea2.svg";